import { Box, Tooltip, Typography } from "@mui/material";
import { BomItemDetails } from "../../../../../explorer/types/SpareParts/BomItemDetails";

type TItemTextComponent = {
    item: BomItemDetails;
};

const ItemTextComponent = (props: TItemTextComponent) => {
    return (
        <Box>
            <Typography component="div">
                {props.item.item || props.item.code}
            </Typography>
        </Box>
    );
};

export default ItemTextComponent;
